// extracted by mini-css-extract-plugin
export default {"buttonGroup":"TMDfz8M_1Zi0bqsRJRSA","label":"aK_kei437lS7ULiRQ6st"};